import { siteContent } from "../content";
const bySubscribing = siteContent.bySubscribing;

const BySubscribing = () => (
  <div className="mt-14 md:mt-24">
    <h2 className="text-center text-3xl">{bySubscribing.title}</h2>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-10 mt-14 text-lg text-center">
      {bySubscribing.content.map((item, k) => (
        <div key={k} className="bg-white px-5 py-10 shadow-lg shadow-gray-100">
          <div className="w-12 h-12 block mx-auto mb-5">
            <img src={item.img} alt={item.title} />
          </div>
          {item.title}
        </div>
      ))}
    </div>
  </div>
);

export default BySubscribing;
